import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import Loader from 'components/ui/Loader';
import { decrypt } from 'utils/functions';

// eslint-disable-next-line react/prop-types
export function PrivateRoute({ component: Component, path, exact, token }) {
  const primaryComp = (
    <Route
      exact={exact}
      path={path}
      render={(props) => (
        <Suspense fallback={<Loader position="absolute" showBackground />}>
          <Component {...props} />
        </Suspense>
      )}
    />
  );
  const route = token ? primaryComp : <Route render={() => <Redirect to="/" />} />;

  return route;
}
export function PrivateRouteAdmin({ component: Component, path, exact, token }) {
  const usertypestr = localStorage.getItem('usertype');
  const usertype = decrypt(usertypestr);
  const primaryComp = (
    <Route
      exact={exact}
      path={path}
      render={(props) => (
        <Suspense fallback={<Loader position="absolute" showBackground />}>
          <Component {...props} />
        </Suspense>
      )}
    />
  );
  const route = token && usertype == 1 ? primaryComp : <Route render={() => <Redirect to="/" />} />;

  return route;
}

PrivateRoute.defaultProps = {
  exact: false,
  token: null
};

PrivateRoute.propTypes = {
  exact: PropTypes.bool,
  token: PropTypes.string,
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired
};
